import get from 'lodash/get';

import env from 'Env';
import { currencyCode } from 'Helpers/Geo/data';
import ProductRequirements from 'Helpers/Product/ProductRequirements';
import cleanDisplayName from 'Components/Product/Seo/CleanDisplayName';
import isPrerender from 'Helpers/SEO/is-prerender';

/**
 * Convert user reviews into google structured data
 * @param  {Array.Object} reviews
 * @param  {Object}       product
 * @param  {Boolean}      nested
 * @return {Array.Object|undefined}
 */
export default function reviewStructuredData(reviews, product, nested) {
  if (!reviews || !reviews.length) {
    return undefined;
  }

  let availability = 'InStock';

  if (product.sold_out) {
    availability = 'SoldOut';
  }

  if (ProductRequirements.isPreorder(product)) {
    availability = 'PreOrder';
  }

  const productUrl = `https://${env.appUrl}/${window.locale || 'en'}/${product.type || 'game'}/${product.slug}`;

  return reviews.map(r => ({
    '@type': 'Review',
    '@id': `${productUrl}/reviews#${r._id}`,
    reviewRating: {
      '@type': 'Rating',
      ratingValue: r.rating,
      bestRating: 5,
      worstRating: 1,
    },
    author: {
      '@type': 'Person',
      name: cleanDisplayName(r.display_name),
    },
    reviewBody: r.text,
    inLanguage: r.locale,
    datePublished: r.date,
    itemReviewed: !nested ? {
      '@id': `${productUrl}#product`,
      url: productUrl,
      image: `${env.cdnExtUrl}/product/1280x720/${product.cover}`,
      mainEntityOfPage: {
        '@id': `${productUrl}#webpage`,
        '@type': 'ItemPage',
      },
      name: product.name,
      '@type': 'Product',
      offers: [isPrerender() ? 'USD' : currencyCode].map((code) => {
        const offer = {
          '@type': 'Offer',
          price: get(product, `currentPrice.${code}`, get(product, `price.${code}`, 0)) / 100,
          priceCurrency: code,
          availability,
          priceValidUntil: new Date(Date.now() + (1000 * 60 * 60 * 48)).toISOString(), // default
          url: `https://${env.appUrl}/${window.locale || 'en'}/${product.type || 'game'}/${product.slug}`,
        };

        if (product.current_discount &&
          product.current_discount.percent &&
          product.current_discount.until
        ) {
          offer.priceValidUntil = product.current_discount.until;
        }

        if (product.bundles && product.bundles.length > 1) {
          offer['@type'] = 'AggregateOffer';
          offer.lowPrice = offer.price;
          const topTier = product.bundles[product.bundles.length - 1];
          offer.highPrice = get(topTier, `currentPrice.${code}`, get(topTier, `price.${code}`, 0)) / 100;
          offer.offerCount = product.bundles.length;
          offer.price = undefined;
        }

        return offer;
      }),
    } : undefined,
  }));
}
